// Module
var code = "<react-component name=\"RecentActivity\"></react-component>\n";
// Exports
module.exports = code;